import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { get, isEmpty } from 'es-toolkit/compat'

import type { AppState } from 'state/index'

import type { Tenant } from 'state/account'

export default function AccountDisabledPage() {
  const { t } = useTranslation()
  const partner: Tenant = useSelector((state) =>
    get(state as AppState, 'account.partnerContactDetails'),
  )

  let partnerName: string | undefined = 'FarmTRX'
  let partnerEmail: string | undefined = 'support@farmtrx.com'
  if (!isEmpty(partner)) {
    partnerName = partner.fullName
    partnerEmail = partner.email
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 12, lg: 12 }}>
        {t('account_deactivated', {
          partner_name: partnerName,
        })}
      </Grid>
      {partnerEmail ? (
        <Grid size={{ md: 12, lg: 12 }}>
          {t('email')} {partnerEmail}
        </Grid>
      ) : null}
      {partner?.phoneNumber ? (
        <Grid size={{ md: 12, lg: 12 }}>
          {t('phone_number')} {partner?.phoneNumber}
        </Grid>
      ) : null}
    </Grid>
  )
}
